<div>
  <lp-language-tabs [languages]="languageTabs()" [activeIndex]="activeIndex()" (activeIndexChange)="selectLanguage($event)" />

  <div class="dm-margin-vertical-16">
    <dm-input
      type="textarea"
      [rows]="multilineName() ? 4 : 1"
      [singleline]="!multilineName()"
      [autosize]="true"
      [debounceInMs]="environmentUser.uiDebounceTime"
      [label]="nameLabel() ?? defaultNameLabel"
      [required]="requiredAll() || isAnyLanguageRequired()"
      [invalid]="!!activeNameError()"
      [errormsg]="activeNameError()"
      [value]="$any(activeLanguage()?.name)"
      (dmInput)="inputChanged($event.detail.value, 'name')"
    />
  </div>
  <!-- Fields of the caller's own that belong between the name and the description, such as a news
       entry's link; they follow the language through the `languageChanged` output. -->
  <ng-content />
  @if (!showBeschreibung()) {
    <!-- Name only -->
  } @else if (richtextBeschreibung()) {
    <dm-label for="beschreibung-richtext" [required]="isBeschreibungRequired()">
      {{ beschreibungLabel() ?? defaultBeschreibungLabel }}
    </dm-label>
    <dm-richtext-editor
      id="beschreibung-richtext"
      [prose]="false"
      [stickyToolbar]="false"
      toolbarAlign="left"
      [toolbarButtons]="toolbarButtons()"
      [allowImages]="imagesEnabled()"
      [imageUploadHandler]="imageUploadHandler()"
      (dmImageUploadError)="imageUploadFailed.emit($event.detail.error)"
      (dmImageInserted)="imageInserted.emit()"
      [content]="activeLanguage()?.beschreibung ?? ''"
      (dmContentChange)="inputChanged($event.detail, 'beschreibung')"
    />
  } @else {
    <dm-input
      [debounceInMs]="environmentUser.uiDebounceTime"
      [required]="isBeschreibungRequired()"
      [maxLength]="beschreibungMaxLength"
      [hint]="beschreibungCharactersLeft()"
      type="textarea"
      [label]="beschreibungLabel() ?? defaultBeschreibungLabel"
      [rows]="5"
      [autosize]="true"
      [value]="$any(activeLanguage()?.beschreibung)"
      (dmInput)="inputChanged($event.detail.value, 'beschreibung')"
    />
    @if (showInterneBeschreibung()) {
      <div class="dm-margin-top-16">
        <dm-input
          [debounceInMs]="environmentUser.uiDebounceTime"
          type="textarea"
          [label]="interneBeschreibungLabel"
          [rows]="5"
          [autosize]="true"
          [value]="$any(activeLanguage()?.interneBeschreibung)"
          (dmInput)="inputChanged($event.detail.value, 'interneBeschreibung')"
        />
      </div>
    }
  }
</div>
